module.exports = __webpack_public_path__ + "static/media/password_reset_email_sent.17db02dc.svg";